module.exports = __webpack_public_path__ + "img/result_ok_small.af16207b.svg";